import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=3a5a9b5e&scoped=true&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5a9b5e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/pushhike/pushhike-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a5a9b5e')) {
      api.createRecord('3a5a9b5e', component.options)
    } else {
      api.reload('3a5a9b5e', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=3a5a9b5e&scoped=true&", function () {
      api.rerender('3a5a9b5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/Pagination.vue"
export default component.exports